import Dashboard from "../components/Dashboard"

const DynamicUI = () => {
    return <Dashboard />
}
export default DynamicUI